import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59a51b98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1))
const _hoisted_3 = { class: "sm:col-span-4 main-content" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "bottom-0 absolute p-2 sm:max-w-half"
}
const _hoisted_8 = ["href", "innerHTML"]
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", {
              class: _normalizeClass(["text-3xl font-medium", {'text-project-dark': !_ctx.config.themeDark}]),
              innerHTML: _ctx.TR(_ctx.config.title, {name: _ctx.state.nickname.value})
            }, null, 10, _hoisted_4),
            (_ctx.config.textPart1)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "mt-4",
                  innerHTML: _ctx.TR(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["mt-8 justify-items-stretch flex flex-col", {['grid-flow-col-dense grid-rows-'+_ctx.config.maxRows]: _ctx.config.maxRows}])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.options, (option, key) => {
                return (_openBlock(), _createBlock(_component_ActionButton, {
                  key: key,
                  selected: _ctx.state.answers.value?.[_ctx.config.answerKey] === key,
                  class: _normalizeClass(["options-button mb-4 text-left", _ctx.config.classes?.buttonClasses]),
                  preicon: _ctx.optionsWithAnswersDone?.[key] ? '✓' : '',
                  "button-class": "answer-button",
                  onClick: ($event: any) => (_ctx.answer(key, {[key]: _ctx.$t(option)})),
                  rawtext: _ctx.TR(option)
                }, null, 8, ["selected", "class", "preicon", "onClick", "rawtext"]))
              }), 128))
            ], 2)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["sm:col-span-4 h-full min-h-50vh flex flex-col items-center justify-center", _ctx.config.classes.rightSide])
          }, [
            (_ctx.config.bgImage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "bg-project w-full p-16 aspect-square flex flex-col items-center justify-center",
                  style: _normalizeStyle(_ctx.config.bgStyles)
                }, [
                  _createElementVNode("img", {
                    src: _ctx.config.bgImage,
                    class: _normalizeClass(["w-full", _ctx.config.classes?.bgImageClasses]),
                    alt: "Logo"
                  }, null, 10, _hoisted_6)
                ], 4))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        (_ctx.config.source)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.config.source.link)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.TR(_ctx.config.source.link),
                    class: "text-xs text-gray-900 hover:text-gray-400",
                    target: "_blank",
                    innerHTML: _ctx.TR(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_8))
                : (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "text-xs",
                    innerHTML: _ctx.TR(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_9))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}